const formDefCache = {};
const pendingLoads = {};

function cacheKey(modelId, view) {
  return `${modelId}::${view || 'editor'}`;
}

export function getCachedFormDef(modelId, view) {
  if (!modelId) return null;
  return formDefCache[cacheKey(modelId, view)] || null;
}

export function loadRemoteFormDef({ store, api, modelId, view }) {
  const v = view || 'editor';
  const key = cacheKey(modelId, v);
  const cached = formDefCache[key];
  if (cached) {
    return Promise.resolve(cached);
  }
  if (pendingLoads[key]) {
    return pendingLoads[key];
  }
  pendingLoads[key] = new Promise((resolve, reject) => {
    api.afterLogin(() => {
      store.dispatch('model/load', { id: modelId, view: v })
        .then((def) => {
          formDefCache[key] = def;
          resolve(def);
        })
        .catch(reject)
        .finally(() => {
          delete pendingLoads[key];
        });
    });
  });
  return pendingLoads[key];
}
